/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const RestrictionCheckSummaryDTOMarketplaceEnum = {
    UnitedStates: 'UNITED_STATES',
    Brazil: 'BRAZIL',
    Canada: 'CANADA',
    Mexico: 'MEXICO',
    Australia: 'AUSTRALIA',
    Japan: 'JAPAN',
    India: 'INDIA',
    Singapore: 'SINGAPORE',
    Germany: 'GERMANY',
    Spain: 'SPAIN',
    France: 'FRANCE',
    Italy: 'ITALY',
    Netherlands: 'NETHERLANDS',
    Belgium: 'BELGIUM',
    Poland: 'POLAND',
    Sweden: 'SWEDEN',
    UnitedKingdom: 'UNITED_KINGDOM',
    Ireland: 'IRELAND',
    UnitedArabEmirates: 'UNITED_ARAB_EMIRATES',
    Egypt: 'EGYPT',
    SaudiArabia: 'SAUDI_ARABIA',
    All: 'ALL'
};
/**
 * @export
 */
export const RestrictionCheckSummaryDTOStatusEnum = {
    Queued: 'QUEUED',
    Running: 'RUNNING',
    Completed: 'COMPLETED',
    Cancelled: 'CANCELLED'
};
/**
 * Check if a given object implements the RestrictionCheckSummaryDTO interface.
 */
export function instanceOfRestrictionCheckSummaryDTO(value) {
    return true;
}
export function RestrictionCheckSummaryDTOFromJSON(json) {
    return RestrictionCheckSummaryDTOFromJSONTyped(json, false);
}
export function RestrictionCheckSummaryDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'marketplace': json['marketplace'] == null ? undefined : json['marketplace'],
        'status': json['status'] == null ? undefined : json['status'],
        'totalCount': json['totalCount'] == null ? undefined : json['totalCount'],
        'checkedCount': json['checkedCount'] == null ? undefined : json['checkedCount'],
        'unrestrictedCount': json['unrestrictedCount'] == null ? undefined : json['unrestrictedCount'],
        'approvalRequiredCount': json['approvalRequiredCount'] == null ? undefined : json['approvalRequiredCount'],
        'notEligibleCount': json['notEligibleCount'] == null ? undefined : json['notEligibleCount'],
        'notFoundCount': json['notFoundCount'] == null ? undefined : json['notFoundCount'],
        'errorCount': json['errorCount'] == null ? undefined : json['errorCount'],
        'chunkIndex': json['chunkIndex'] == null ? undefined : json['chunkIndex'],
        'chunkCount': json['chunkCount'] == null ? undefined : json['chunkCount'],
        'submissionId': json['submissionId'] == null ? undefined : json['submissionId'],
        'createdDate': json['createdDate'] == null ? undefined : (new Date(json['createdDate'])),
        'startedAt': json['startedAt'] == null ? undefined : (new Date(json['startedAt'])),
        'finishedAt': json['finishedAt'] == null ? undefined : (new Date(json['finishedAt'])),
        'searchAsinCount': json['searchAsinCount'] == null ? undefined : json['searchAsinCount'],
        'autoSearch': json['autoSearch'] == null ? undefined : json['autoSearch'],
        'autoSearchDispatchedAt': json['autoSearchDispatchedAt'] == null ? undefined : (new Date(json['autoSearchDispatchedAt'])),
        'skuSegment': json['skuSegment'] == null ? undefined : json['skuSegment'],
    };
}
export function RestrictionCheckSummaryDTOToJSON(json) {
    return RestrictionCheckSummaryDTOToJSONTyped(json, false);
}
export function RestrictionCheckSummaryDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'name': value['name'],
        'marketplace': value['marketplace'],
        'status': value['status'],
        'totalCount': value['totalCount'],
        'checkedCount': value['checkedCount'],
        'unrestrictedCount': value['unrestrictedCount'],
        'approvalRequiredCount': value['approvalRequiredCount'],
        'notEligibleCount': value['notEligibleCount'],
        'notFoundCount': value['notFoundCount'],
        'errorCount': value['errorCount'],
        'chunkIndex': value['chunkIndex'],
        'chunkCount': value['chunkCount'],
        'submissionId': value['submissionId'],
        'createdDate': value['createdDate'] == null ? undefined : ((value['createdDate']).toISOString()),
        'startedAt': value['startedAt'] == null ? undefined : ((value['startedAt']).toISOString()),
        'finishedAt': value['finishedAt'] == null ? undefined : ((value['finishedAt']).toISOString()),
        'searchAsinCount': value['searchAsinCount'],
        'autoSearch': value['autoSearch'],
        'autoSearchDispatchedAt': value['autoSearchDispatchedAt'] == null ? undefined : ((value['autoSearchDispatchedAt']).toISOString()),
        'skuSegment': value['skuSegment'],
    };
}
